import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetSectors } from '@/hooks/useGetSectors';
import { SelectOptions } from '@/components/ui/SelectOptions';
import * as S from '@/components/Settings/DataExtraction/styles';

const { useFormInstance, useWatch } = Form;

export function SectorFormItem(): JSX.Element {
	const form = useFormInstance();
	const organization_id: string = useWatch(['general_information', 'organization_id']);
	const company_id: string = useWatch(['general_information', 'company_id']);

	const sectors = useGetSectors({
		organization_id,
		company_id
	});

	function handleOnChange(): void {
		form.setFieldValue(['general_information', 'line_id'], undefined);
		form.setFieldValue(['general_information', 'workstation_id'], undefined);
	}

	const isDisabled: boolean = !organization_id || !company_id;

	return (
		<S.CustomFormItem
			name={['general_information', 'sector_id']}
			label={I18n.get('Sector')}
			labelCol={{ span: 24 }}
		>
			<SelectOptions
				allowClear
				disabled={isDisabled}
				options={sectors.data}
				onChange={handleOnChange}
				loading={sectors.isFetching}
				placeholder={I18n.get('Sector')}
			/>
		</S.CustomFormItem>
	);
}
